import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import * as DB from '../../../database'

export default {
  namespaced: true,

  state: {
    localId: null,
    remoteId: null,
    roomId: null,
    peerConnection: null,
    messageHandlerRef: null,
    localStream: null,
    remoteStream: null,
    iceConnectionState: null,
    connectionSuccessful: false,
    connectionRelayed: false
  },

  mutations: {
    reset (state) {
      state.localId = null
      state.remoteId = null
      state.roomId = null
      if (state.peerConnection !== null) {
        state.peerConnection.close()
        state.peerConnection.onicecandidate = null
        state.peerConnection.onaddstream = null
        state.peerConnection.oniceconnectionstatechange = null
        state.peerConnection = null
        state.messageHandlerRef = null
      }
      // state.localStream = null // We keep it for the next time
      // document.getElementById('localVideo').srcObject = null // We keep it for the next time
      state.remoteStream = null
      document.getElementById('remoteVideo').srcObject = null
      state.iceConnectionState = null
      state.connectionSuccessful = false
      state.connectionRelayed = false
    },

    setEndPoints (state, { localId, remoteId }) {
      state.localId = localId
      state.remoteId = remoteId
    },

    setRoomId (state, { roomId }) {
      state.roomId = roomId
    },

    setPeerConnection (state, { peerConnection }) {
      state.peerConnection = peerConnection
    },

    setOnIceCandidateHandler (state, { handler }) {
      state.peerConnection.onicecandidate = handler
    },

    setOnAddStreamHandler (state, { handler }) {
      state.peerConnection.onaddstream = handler
    },

    setOnIceConnectionStateChange (state, { handler }) {
      state.peerConnection.oniceconnectionstatechange = handler
    },

    setMessageHandlerRef (state, { handlerRef }) {
      state.messageHandlerRef = handlerRef
    },

    setLocalStream (state, { stream }) {
      state.localStream = stream
      document.getElementById('localVideo').srcObject = stream
    },

    setRemoteStream (state, { stream }) {
      state.remoteStream = stream
      document.getElementById('remoteVideo').srcObject = stream
    },

    setIceConnectionState (state, { iceConnectionState }) {
      state.iceConnectionState = iceConnectionState
      if (iceConnectionState === 'connected') {
        state.connectionSuccessful = true
      }
    },

    setConnectionSuccessful (state, { connectionSuccessful }) {
      state.connectionSuccessful = connectionSuccessful
    },

    setConnectionRelayed (state, { connectionRelayed }) {
      state.connectionRelayed = connectionRelayed
    }
  },

  actions: {
    start ({ state, commit, dispatch }, { localId, remoteId, roomId, sendOffer }) {
      global.DEBUG && console.log('video started')
      commit('setPeerConnection', {
        peerConnection: new RTCPeerConnection({'iceServers': [{'urls': 'stun:stun.services.mozilla.com'}, {'urls': 'stun:stun.l.google.com:19302'}, {'urls': 'turn:numb.viagenie.ca', 'credential': 'JFV6mDOmmv7Mv9KC195D', 'username': 'gregory.journe@nurgo-software.com'}]})
      })
      return dispatch('initializeLocalStream').then(() => {
        commit('setEndPoints', { localId: localId, remoteId: remoteId })
        commit('setRoomId', { roomId: roomId })
        commit('setOnIceCandidateHandler', {
          handler: event => event.candidate ? dispatch('sendWebRtcMessage', JSON.stringify({ ice: event.candidate })) : (global.DEBUG && console.log('Sent All Ice'))
        })
        commit('setOnAddStreamHandler', {
          handler: event => (commit('setRemoteStream', { stream: event.stream }))
        })
        commit('setOnIceConnectionStateChange', {
          handler: () => {
            commit('setIceConnectionState', { iceConnectionState: state.peerConnection.iceConnectionState })
            state.peerConnection.getStats().then(stats => {
              let selected = [...stats.values()].find(s => s.type === 'candidate-pair' && s.selected)
              if (!selected) { return }
              var candidate = stats.get(selected.localCandidateId)
              if (candidate.candidateType === 'relayed') {
                commit('setConnectionRelayed', { connectionRelayed: true })
              }
            })
          }
        })
        let messageHandlerRef = firebase.database().ref(String.format(DB.WEBRTC_ROOM_USER, roomId, localId)).on('child_added', message => {
          dispatch('handleWebRtcMessage', message.val())
        })
        commit('setMessageHandlerRef', { messageHandlerRef: messageHandlerRef })
        if (sendOffer) {
          state.peerConnection.createOffer()
            .then(offer => state.peerConnection.setLocalDescription(offer))
            .then(() => {
              dispatch('sendWebRtcMessage', JSON.stringify({ sdp: state.peerConnection.localDescription }))
            })
        }
      })
    },

    stop ({ state, commit }) {
      global.DEBUG && console.log('video stopped')
      firebase.database().ref(String.format(DB.WEBRTC_ROOM_USER, state.roomId, state.localId)).off('child_added', state.messageHandlerRef)
      commit('reset')
    },

    initializeLocalStream ({ state, commit }) {
      if (state.localStream === null) {
        return navigator.mediaDevices.getUserMedia({audio: true, video: true}).then(stream => {
          commit('setLocalStream', { stream: stream })
          state.peerConnection.addStream(stream)
        })
      }
      state.peerConnection.addStream(state.localStream)
      return null
    },

    sendWebRtcMessage ({ state }, message) {
      return firebase.database().ref(String.format(DB.WEBRTC_ROOM_USER, state.roomId, state.remoteId)).push(message)
    },

    handleWebRtcMessage ({ state, dispatch }, message) {
      global.DEBUG && console.log('handleWebRtcMessage: ' + JSON.stringify(message))
      let msg = JSON.parse(message)
      if (msg.ice !== undefined) {
        state.peerConnection.addIceCandidate(new RTCIceCandidate(msg.ice))
      } else if (msg.sdp.type === 'offer') {
        state.peerConnection.setRemoteDescription(new RTCSessionDescription(msg.sdp))
          .then(() => state.peerConnection.createAnswer())
          .then(answer => state.peerConnection.setLocalDescription(answer))
          .then(() => dispatch('sendWebRtcMessage', JSON.stringify({'sdp': state.peerConnection.localDescription})))
      } else if (msg.sdp.type === 'answer') {
        state.peerConnection.setRemoteDescription(new RTCSessionDescription(msg.sdp))
      }
    },

    updateLocalSnapshot ({ state }, { blob }) {
      if (!state.localStream) { return }
      return firebase.storage().ref('preview/' + state.localId).put(blob)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/room/video/index.js